// Small presentation helpers for the Admin section. Kept out of the .tsx
// component files so react-refresh fast-refresh works (a file should export
// either components OR plain helpers, not both).

/** Show a person's display name, falling back to their phone / id. */
export function personName(p: { first_name: string; last_name: string; phone: string; id: number }): string {
  const n = `${p.first_name} ${p.last_name}`.trim();
  return n || p.phone || `#${p.id}`;
}

/** Compact km-credit formatter (2 dp + " km"). */
export function km(n: number): string {
  return `${(n ?? 0).toFixed(2)} km`;
}

/** A short ISO date → local date+time, or "—". */
export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
}
